// extracted by mini-css-extract-plugin
export var chevron = "_2b-d";
export var disabled = "_2b-b";
export var error = "_2b-c";
export var hideBorder = "_2b-1";
export var icon = "_2b-e";
export var input = "_2b-0";
export var large = "_2b-f";
export var open = "_2b-9";
export var placeholder = "_2b-a";
export var regular = "_2b-5";
export var singleRowInput = "_2b-2";
export var singleSelectInput = "_2b-3 _2b-0";
export var small = "_2b-4";
export var spinnerContainer = "_2b-i";
export var tag = "_2b-7";
export var tagsContainer = "_2b-8";
export var tagsInput = "_2b-6 _2b-0";
export var xSmall = "_2b-g";
export var xxSmall = "_2b-h";